import { DataTable, ExtendedColumnDef } from "@/components/Datatable";
import { useGetPriceRemarkReasonsQuery } from "@/services/price-remark/justification-reasons";
import { PriceRemarkReason } from "@/services/price-remark/types";

import { CreateReasonDialog, EditReasonDialog } from "./reason-form-dialog";

const columns: ExtendedColumnDef<PriceRemarkReason>[] = [
  { accessorKey: "contexto", header: "Contexto" },
  { accessorKey: "ordem", header: "Ordem" },
  { accessorKey: "codigo", header: "Código" },
  { accessorKey: "rotulo", header: "Rótulo" },
  {
    accessorKey: "ativo",
    header: "Ativo",
    cell: ({ row }) => (row.original.ativo ? "Sim" : "Não"),
  },
  { accessorKey: "usos90d", header: "Usos (90d)" },
  {
    id: "acoes",
    header: "Ações",
    cell: ({ row }) =>
      row.original.editavel ? (
        <EditReasonDialog reason={row.original} />
      ) : (
        <span className="text-xs text-gray-400">somente leitura</span>
      ),
  },
];

export function ReasonsTab() {
  const { data: reasons = [], isFetching } = useGetPriceRemarkReasonsQuery();

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="max-w-2xl text-sm text-gray-500">
          Só o contexto <b>CNF</b> consome catálogo. IMP/REI/SME são texto livre
          por decisão de produto (somente leitura — exige nova versão do app para
          usar catálogo). Motivo se <b>desativa</b>, nunca se apaga.
        </p>
        <CreateReasonDialog />
      </div>

      <DataTable
        columns={columns}
        data={reasons}
        isLoading={isFetching}
        emptyMessage="Nenhum motivo cadastrado."
      />
    </div>
  );
}

export default ReasonsTab;
